import React, { useContext, Fragment } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import LeftTail from '../../../asset/img/bubble_point1.png';
import NoticeIcon from '../../../asset/img/ico_cb_notice.svg';
import { openLink } from '../../util/utilNative';

const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.0313rem',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  leftContainer: {
    justifyContent: 'flex-start',
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  message: {
    fontSize: theme.font.size15, // "15px",
    borderRadius: '0.75rem',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    maxWidth: '75%',
    zIndex: 10,
    wordWrap: 'break-word',
  },
  cbMessage: {
    width: '100%',
    // fontSize: theme.font.size15, // "15px",
    // borderRadius: "12px",
    // flexWrap: "wrap",
    // color: theme.color.message.color,
    // zIndex: 10,
    // wordWrap: "break-word",
  },
  leftMessage: {
    backgroundColor: theme.color.message.background,
    margin: '0.375rem 0.375rem 0.375rem 0.5625rem',
    boxShadow: '0rem 0.75rem 0.75rem rgba(194, 194, 194, 0.58)',
    fontWeight: '300',
  },
  rightMessage: {
    backgroundColor: theme.color.message.background,
    margin: '0.5rem 0.625rem',
    boxShadow: 'none',
  },

  list: {
    display: 'flex',
    width: '100%',
    borderRadius: '0rem 0rem 0.75rem 0.75rem',
    border: '0rem',
    alignItems: 'center',
    background: '#fafafa',
  },
  item: {
    height: '2.5rem',
    textAlign: 'center',
    color: theme.color.accent,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    margin: '0rem',
    flex: 1,
    backgroundColor: '#FAFAFA',
    textTransform: 'none',
    // outline: '0 none',
    border: '0rem',
    borderRadius: '0rem 0rem 0.75rem 0.75rem',
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  itemLeft: {
    borderRadius: '0.125rem 0rem 0rem 0.0625rem',
  },
  itemRight: {
    borderRadius: '0px 0px 12px 0px',
  },
  itemDisabled: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  vertical: {
    height: '1.25rem',
    backgroundColor: theme.color.list_divider,
  },
  leftTail: {
    // borderLeft: '14px solid transparent',
    // borderRight: '14px solid transparent',
    // borderTop: '18px solid #fff',
    // borderRadius: '5px',
    zIndex: 11,
    margin: '0.375rem -1.3125rem 0rem 0.6875rem',
    backgroundImage: `url(${LeftTail})`,
    backgroundSize: '1.3125rem 0.75rem',
    width: '1.3125rem',
    height: '0.75rem',
    minWidth: '1.3125rem',
  },
  ti: {
    width: '100%',
    padding: '0.75rem 1.25rem',
    margin: '0rem',
  },
  title: {
    fontSize: theme.font.size15, // "15px",
    fontWeight: 'bold',
    color: theme.color.text,
  },
  tiList: {
    marginTop: '0.75rem',
    color: theme.color.text,
  },
  listRow: {
    display: 'flex',
    alignItems: 'center',
  },
  key: {
    minWidth: '3.75rem',
    height: '2rem',
    fontSize: theme.font.size12,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    height: '2rem',
    fontSize: theme.font.size15, // "15px",
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center',
    color: theme.color.text_color.grey,
  },
  textBox: {
    width: 'auto',
    minHeight: '2.75rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.color.message.background,
    margin: '0.1875rem 1rem',
    display: 'flex',
    color: theme.color.message.color,
    // alignItems: "center",
    justifyContent: 'flex-start',
    padding: '1rem',
    fontSize: theme.font.size14,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  tiBox: {
    width: 'auto',
    minHeight: '2.75rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.color.message.background_white,
    margin: '0.1875rem 1rem',
    display: 'flex',
    color: theme.color.message.color,
    // alignItems: "center",
    justifyContent: 'flex-start',
    padding: '1rem',
    fontSize: theme.font.size14,
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
  },
  linkStr: {
    color: '-webkit-link',
    cursor: 'pointer',
    textDecoration: 'underline',
    background: 'none',
    border: 'none',
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 0 0.75rem 0',
  },
  titleIcon: {
    minWidth: '1.5rem',
    minHeight: '1.5rem',
  },
  titleStr: {
    color: theme.color.message.color,
    fontSize: theme.font.size15,
    padding: '0 0 0 0.375rem',
    fontWeight: 'bold',
  },
  buttonBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 1rem',
  },
  button0: {
    width: '100%',
    minHeight: '2.875rem', // 46px
    borderRadius: '0.375rem',
    backgroundColor: '#ea1917', //'#da0f47',
    border: '0rem',
    fontWeight: 'bold',
    color: '#fff',
    margin: '0.1875rem 0',
    fontSize: theme.font.size14,
  },
  button1: {
    width: '100%',
    minHeight: '2.875rem', // 46px
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ddd',
    backgroundColor: '#fff',
    fontWeight: 'bold',
    color: '#000',
    margin: '0.1875rem 0',
    fontSize: theme.font.size14,
  },
  buttonMore: {
    width: '100%',
    minHeight: '2.875rem', // 46px
    borderRadius: '0.375rem',
    border: '0px',
    fontWeight: 'bold',
    backgroundColor: '#f6f6f6',
    color: theme.color.message.color,
    margin: '0.1875rem 0',
  },
});

function CB(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (button) => {
    context.request(context, button.speech, 'button');
  };
  const handleOpenLink = (url) => {
    openLink(context, 'inapp', url);
  };
  let cbText = data.text ? data.text : '';
  const regATag = /<a target="_blank" href="([^"]+)">([^<]+)<\/a>/g;
  const regATagExcept = /<a target="_blank" href="[^"]+">[^<]+<\/a>/g;
  cbText = cbText.replace(/(?:\r\n|\r|\n)/g, '<br>');

  let ataginfo = [];
  cbText.replace(regATag, function () {
    ataginfo.push({ href: arguments[1], content: arguments[2] });
  });
  let splitCbText = cbText.split(regATagExcept);

  return data.subType && data.subType.toUpperCase() === 'TI' ? (
    <>
      <div className={classes.root}>
        <div className={classes.cbMessage}>
          {(cbText || data.listItems.length > 0) && (
            <div className={classes.tiBox}>
              {data.title && (
                <div className={classes.titleBox}>
                  <img
                    className={classes.titleIcon}
                    src={NoticeIcon}
                    alt={context.string.aria.icon.imgNotice}
                  />
                  <div className={classes.titleStr}>{data.title}</div>
                </div>
              )}
              {cbText && (
                <div>
                  {splitCbText.map((cur, curIndex) => {
                    return (
                      <Fragment key={`cbtest${curIndex}`}>
                        <span dangerouslySetInnerHTML={{ __html: `${cur}` }} />
                        {curIndex < splitCbText.length - 1 && (
                          <button
                            className={classes.linkStr}
                            onClick={() => handleOpenLink(ataginfo[curIndex].href)}
                          >
                            {' '}
                            {ataginfo[curIndex].content}{' '}
                          </button>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
              )}
              {/* {data.text&&data.text.split("\n").map((content, index) => (
                  <Fragment key={index}>
                    {content}
                    <br />
                  </Fragment>
                ))} */}
              {data.listItems.map((item) => (
                <Grid container className={classes.listRow} role={'text'}>
                  <Grid item className={classes.key}>
                    {item.key}
                  </Grid>
                  <Grid item className={classes.value}>
                    {item.value}
                  </Grid>
                </Grid>
              ))}
            </div>
          )}

          <div className={classes.buttonBox}>
            {data.buttons.map((buttonData, butIndex) => {
              return (
                <button
                  key={`cb_index_${butIndex}`}
                  type="button"
                  className={[
                    butIndex === 0
                      ? classes.button0
                      : butIndex === 1
                      ? classes.button1
                      : classes.buttonMore,
                    data.isLast || context.conversationEnd ? classes.itemDisabled : '',
                  ].join(' ')}
                  disabled={!data.isLast || context.conversationEnd}
                  onClick={() => handleClick(buttonData)}
                >
                  {buttonData.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className={classes.root}>
        <div className={classes.cbMessage}>
          {cbText && (
            <div className={classes.textBox} tabIndex="0">
              {data.title && (
                <div className={classes.titleBox}>
                  <img
                    className={classes.titleIcon}
                    src={NoticeIcon}
                    alt={context.string.aria.icon.imgNotice}
                  />
                  <div className={classes.titleStr}>{data.title}</div>
                </div>
              )}
              {cbText && (
                <div>
                  {splitCbText.map((cur, curIndex) => {
                    return (
                      <Fragment key={`cbtest${curIndex}`}>
                        <span dangerouslySetInnerHTML={{ __html: `${cur}` }} />
                        {curIndex < splitCbText.length - 1 && (
                          <button
                            className={classes.linkStr}
                            onClick={() => handleOpenLink(ataginfo[curIndex].href)}
                          >
                            {' '}
                            {ataginfo[curIndex].content}{' '}
                          </button>
                        )}
                      </Fragment>
                    );
                  })}
                </div>
              )}

              {/* {data.text.split("\n").map((content, index) => (
                  <Fragment key={index}>
                    {content}
                    <br />
                  </Fragment>
                ))} */}
            </div>
          )}

          <div className={classes.buttonBox}>
            {data.buttons.map((buttonData, butIndex) => {
              return (
                <button
                  key={`cb_index_${butIndex}`}
                  type="button"
                  className={[
                    butIndex === 0
                      ? classes.button0
                      : butIndex === 1
                      ? classes.button1
                      : classes.buttonMore,
                    data.isLast || context.conversationEnd ? classes.itemDisabled : '',
                  ].join(' ')}
                  disabled={!data.isLast || context.conversationEnd}
                  onClick={() => handleClick(buttonData)}
                >
                  {buttonData.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
export default withStyles(styles)(CB);
